import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default from 'react';
import { StyledTag, StyledCheckableTag } from './Tag.styles.js';
import { TagType, TagSize } from './Tag.types.js';
import { useDesignSystemThemeName, cleanProps } from '../utils.js';
import { ClearOutline12 } from '../../icons/12/index.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var prefixCls = 'sok-tag';

var getSizeClass = function getSizeClass(size) {
  switch (size) {
    case TagSize.LARGE:
      return 'sok-tag-lg';

    case TagSize.SMALL:
      return 'sok-tag-sm';

    default:
      return '';
  }
};

var Tag = function Tag(props) {
  var className = props.className,
      size = props.size,
      closable = props.closable,
      closeIcon = props.closeIcon,
      disabled = props.disabled,
      onClose = props.onClose,
      style = props.style,
      children = props.children,
      type = props.type;
  var themeName = useDesignSystemThemeName();
  var classNames = "\n    ".concat(themeName, "\n    ").concat(getSizeClass(size), "\n    ").concat(className || '', "\n    ").concat(closable ? 'sok-tag-closable' : '', "\n    ").concat(disabled ? 'sok-tag-disabled' : '', "\n    ").concat(type, "\n    sok-tag\n  ");

  var componentProps = _objectSpread(_objectSpread({}, cleanProps(props, ['size', 'themeName', 'type'])), {}, {
    style: _objectSpread({}, style),
    className: classNames.replace(/\s*\n\s*/g, ' ')
  });

  return /*#__PURE__*/React__default.createElement(StyledTag, _extends({}, componentProps, closable ? {
    role: 'button',
    tabIndex: -1
  } : {}, disabled ? {
    'aria-disabled': true
  } : {
    onClick: onClose,
    onKeyPress: function onKeyPress(event) {
      return event.key === 'Enter' && onClose && onClose(event);
    }
  }), children, closable && /*#__PURE__*/React__default.createElement("span", {
    className: "close-icon"
  }, closeIcon));
};

Tag.defaultProps = {
  type: TagType.DEFAULT,
  size: TagSize.MIDDLE,
  'data-test-id': 'Tag',
  closeIcon: /*#__PURE__*/React__default.createElement(ClearOutline12, null)
};

var CheckableTag = function CheckableTag(props) {
  var className = props.className,
      size = props.size,
      type = props.type,
      checked = props.checked,
      style = props.style;
  var themeName = useDesignSystemThemeName();
  var checkableClass = "".concat(prefixCls, "-checkable");
  var checkableClassChecked = "".concat(prefixCls, "-checkable-checked");
  var classNames = "\n    ".concat(themeName, "\n    ").concat(getSizeClass(size), "\n    ").concat(className || '', "\n    sok-tag\n    ").concat(type, "\n    ").concat(checkableClass, "\n    ").concat(checked ? checkableClassChecked : '', "\n  ");

  var componentProps = _objectSpread(_objectSpread({}, cleanProps(props, ['size', 'themeName'])), {}, {
    style: _objectSpread({}, style),
    className: classNames.replace(/\s*\n\s*/g, ' ')
  });

  return /*#__PURE__*/React__default.createElement(StyledCheckableTag, componentProps);
};

CheckableTag.defaultProps = {
  type: TagType.PRIMARY,
  size: TagSize.MIDDLE,
  'data-test-id': 'CheckableTag'
};

export { CheckableTag, Tag, Tag as default };
//# sourceMappingURL=Tag.js.map
